export default "__VITE_ASSET__Dm9HOi8b__"